import React from "react";
import ReactDOM from "react-dom/client";

import "@/index.css";
import App from "@/App";

// ----------------------------------------
// Chat Widget Loader
// ----------------------------------------

if (!window.__chatWidgetLoaded) {

    window.__chatWidgetLoaded = true;

    window.ChatWidgetConfig = {
        clientId: "client_8ea8a828cc2ab79f",
        domain: window.location.hostname,
        theme: "light",
        position: "bottom-right",
    };

    const script = document.createElement("script");

    script.src =
        "https://shaantabai.com/corp/chat-widget.js";

    script.async = true;

    document.body.appendChild(script);
}

// ----------------------------------------
// React App
// ----------------------------------------

const root = ReactDOM.createRoot(
    document.getElementById("root")
);

root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);